import { Fragment, useState, useEffect, useContext, useRef } from 'react'
import axios from "axios";

import { get, ref } from "firebase/database";

import { db } from '../../../utils/firebaseApp.js';
import { AuthContext } from "../../../utils/auth.js";

import { Menu, Dialog, Transition, Listbox } from '@headlessui/react'
import { ExclamationTriangleIcon, CheckIcon } from '@heroicons/react/24/outline'
import { ArrowLeftIcon, ArrowRightIcon, ChevronRightIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { TrashIcon as CustomTrashIcon, ArrowDownTrayIcon as CustomDownloadIcon, ClipboardDocumentIcon as CustomShareIcon } from '@heroicons/react/20/solid'
import { XMarkIcon } from '@heroicons/react/20/solid'

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import toast from 'react-hot-toast';
import { handleGenerateJson, handleGenerateExcel, handleGenerateCsv, handleGenerateWord } from '../../../components/functions/exportData.js';

import ImageViewerWithHighlights from '../../../components/ImageViewerWithHighlights.js';
import PDFViewerWithHighlights from '../../../components/PDFViewerWithHighlights.js';
import PDFViewer from './PDFViewer.js';
import { FileText, CheckCircle, PercentCircle, FileType } from 'lucide-react';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const ViewFile = ({ classificationId, batchId, fileIds, firstIndex, closeModal, classification }) => {
    const { currentUser } = useContext(AuthContext);
    let userId = currentUser.uid;

    const serverUrl = process.env.REACT_APP_SERVER_URL;

    const [isLoading, setIsLoading] = useState(false);

    const extractionId = 'TEST-EXTRACT-ID'
    const initialFileStatus = 'TEST-STATUS'

    const [fileData, setFileData] = useState(null);
    const [pagesData, setPagesData] = useState([]);
    const [extraction, setExtraction] = useState(null)
    const [extractionResult, setExtractionResult] = useState(null)
    const [showHighlights, setShowHighlights] = useState(true);
    const [noCoordinates, setNoCoordinates] = useState(false);
    const [index, setIndex] = useState(firstIndex);
    const [extractionStatus, setExtractionStatus] = useState(null);


    useEffect(() => {
        if (index === undefined || index === null || fileIds.length === 0) return;
        const fetchFileData = async () => {
            const queryPath = 'document_classification/files/' + userId + '/' + classificationId + '/' + batchId + '/' + fileIds[index];
            console.log("queryPath", queryPath);
            console.log("fileIds", fileIds);
            const itemsRef = ref(db, queryPath);
            const snapshot = await get(itemsRef);
            const fileData = snapshot.val();
            console.log("fileData", fileData);
            setFileData(fileData);
            setFileName(fileData.name);
            setFileStatus(fileData.status);
            setFileDocumentType(fileData.result.documentType);
            if (fileData.extraction && fileData.extraction.status === "waiting") {
                setExtractionStatus("waiting");
            } else if (fileData.extraction && fileData.extraction.status === "error") {
                setExtractionStatus("error");
            }
            if (!fileData.extraction || fileData.extraction.status === "error" || fileData.extraction.status === "waiting") {
                setPagesData(transformDBDataToPages(fileData.coordinates ?? {}, fileData.documentInfo ?? {}));
                setFileUrl(fileData.url);
                setNoCoordinates(true);
                setFileDocumentInfo(fileData.documentInfo);
            } else {
                console.log("fileData.extraction", fileData.extraction);
                const extractionId = fileData.extraction.extractionId;
                const extractionBatchId = fileData.extraction.batchId;
                const extractionFileId = fileData.extraction.fileId;

                const extractionResultQueryPath = 'files/' + userId + '/' + extractionId + '/' + extractionBatchId + '/' + extractionFileId;
                const extractionQueryPath = 'extractions/' + userId + '/' + extractionId

                const extractionResultRef = ref(db, extractionResultQueryPath);
                const extractionRef = ref(db, extractionQueryPath);

                const snapshotExtractionResult = await get(extractionResultRef);
                const snapshotExtraction = await get(extractionRef);

                const extractionResult = snapshotExtractionResult.val();
                const extraction = snapshotExtraction.val();
                console.log("extractionResult", extractionResult);
                console.log("extraction", extraction);

                setFileUrl(extractionResult.url);
                setExtraction(extraction);
                setExtractionResult(extractionResult);
                setFileDocumentInfo(extractionResult.documentInfo);

                setData(prepereData(extractionResult.result, extraction));
                setInitialData(prepereData(extractionResult.result, extraction));

                console.log("coordinates", extractionResult.coordinates);
                console.log("documentInfo", extractionResult.documentInfo);

                if (!extractionResult.coordinates) {
                    setNoCoordinates(true);
                }

                setPagesData(transformDBDataToPages(extractionResult.coordinates ?? {}, extractionResult.documentInfo ?? {}));
            }
        }
        setFileData(null);
        setPagesData([]);
        setExtraction(null);
        setExtractionResult(null);
        setFileUrl(null);
        setFileName(null);
        setFileStatus(null);
        setFileDocumentInfo(null);
        setNoCoordinates(false);
        setFileDocumentType(null);
        fetchFileData();
        setExtractionStatus(null);
    }, [fileIds, index]);

    const [fileUrl, setFileUrl] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [fileId, setFileId] = useState(null);
    const [fileStatus, setFileStatus] = useState(null);
    const [fileCoordinates, setFileCoordinates] = useState(null);
    const [fileDocumentInfo, setFileDocumentInfo] = useState(null);
    const [fileDocumentType, setFileDocumentType] = useState(null);

    const [showDeleteFile, setShowDeleteFile] = useState(false);

    const [files, setFiles] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const inputRefs = useRef({});
    const [selectedKey, setSelectedKey] = useState(null);

    const prepereData = (data, extraction) => {
        let newData = {};
        extraction.fields.forEach((field) => {
            let key = field.key;
            let fieldType = field.type ?? 'string';
            let itemsType = field.items?.type ?? 'string';

            if (fieldType === "string") {
                newData[key] = data[key] ?? '';
            } else if (fieldType === "object") {
                let defaultObject = {};
                field.properties.forEach((innerField) => {
                    defaultObject[innerField.key] = '';
                });
                newData[key] = data[key] ?? defaultObject;
            } else if (fieldType === "array" && itemsType === "string") {
                newData[key] = data[key] ?? [''];
            } else if (fieldType === "array" && itemsType === "object") {
                let defaultObject = {};
                field.items.properties.forEach((innerField) => {
                    defaultObject[innerField.key] = '';
                });
                newData[key] = data[key] ?? [defaultObject];
            }
        });
        return newData;
    }

    const [data, setData] = useState(null);
    const [initialData, setInitialData] = useState(null);

    const handleFieldClick = (key) => {
        setSelectedKey(key);
        const input = inputRefs.current[key];
        if (input) {
            // First scroll the input into view
            input.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center",
            });

            // Then focus the input after a short delay to ensure scroll is complete
            setTimeout(() => {
                input.focus();
            }, 500); // Adjust timing if needed
        }
    };

    const handleInputFocus = (key) => {
        console.log("handleInputFocus");
        // 🔍 Find the field that this key belongs to (in commonKeys)
        const boxField = pagesData
            .flatMap((page) => page.fields)
            .find((field) => field.commonKeys.includes(key));

        if (boxField) {
            setSelectedKey(key); // for highlighting
            const primaryKey = boxField.key; // only this one has a ref

            const highlight = fieldRefs.current[primaryKey];
            if (highlight) {
                highlight.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                });
            }
        } else {
            setSelectedKey(null);
            // Only show toast when highlights are enabled
            if (showHighlights && !noCoordinates) {
                console.log("No highlight found for this field");
                toast('No highlight found for this field', {
                    position: 'bottom-center',
                    duration: 1000,
                    style: {
                        background: '#333',
                        color: '#fff',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    },
                });
            }
        }
    };

    const updateFileResult = async () => {
        await currentUser.getIdToken().then(async (idToken) => {
            const url = serverUrl + "/updateFileResult";

            await axios.post(url, {
                "extractionId": fileData.extraction.extractionId,
                "batchId": fileData.extraction.batchId,
                "fileId": fileData.extraction.fileId,
                "data": data,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${idToken}`
                }
            }).then(async (response) => {
                if (response.status === 200) {
                    toast.success('File result updated successfully!');

                    setInitialData(data);
                    setData(data);
                } else {
                    toast.error('Error updating file result!');
                }
            }).catch((error) => {
                toast.error('Error updating file result!');
            });
        });
    }

    const handleInputChangeString = (key, value) => {
        setData({
            ...data, [key]: value
        });
    }

    const handleInputChangeObject = (key, subKey, value) => {
        setData({
            ...data,
            [key]: {
                ...data[key],
                [subKey]: value
            }
        });
    }

    const handleInputChangeArrayString = (key, index, value) => {
        setData({
            ...data,
            [key]: data[key].map((item, i) => {
                if (i === index) {
                    return value;
                } else {
                    return item;
                }
            })
        });
    }

    const handleInputChangeArrayObject = (key, index, subKey, value) => {
        setData({
            ...data,
            [key]: data[key].map((item, i) => {
                if (i === index) {
                    return {
                        ...item,
                        [subKey]: value
                    };
                } else {
                    return item;
                }
            })
        });
    }

    const addInputArrayString = (key) => {
        if (data[key].some((item) => item === '')) {
            return;
        }

        setData({
            ...data,
            [key]: [...data[key], '']
        });
    }

    const addInputArrayObject = (key) => {
        if (data[key].some((item) => Object.values(item).every((value) => value === ''))) {
            return;
        }

        let defaultObject = {};
        let fields = extraction.fields.find((field) => field.key === key).items.properties;

        fields.forEach((innerField) => {
            defaultObject[innerField.key] = '';
        });

        setData({
            ...data,
            [key]: [...data[key], defaultObject]
        });
    }

    const deleteInputArrayString = (key, index) => {
        setData({
            ...data,
            [key]: data[key].filter((item, i) => i !== index)
        });
    }

    const deleteInputArrayObject = (key, index) => {
        setData({
            ...data,
            [key]: data[key].filter((item, i) => i !== index)
        });
    }

    const isWordOrError = (fileType) => {
        return (fileType !== 'pdf' && fileType !== 'txt' && fileType !== 'image' && fileType !== 'error');
    }

    const getFileTypeFromUrl = (url) => {
        try {
            const path = url.split('?')[0];
            const extension = path.split('.').pop();
            if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'jfif'].includes(extension)) return 'image';
            return extension;
        } catch (error) {
            return 'error';
        }
    };

    const updateFileStatus = async () => {
        await currentUser.getIdToken().then(async (idToken) => {
            const url = serverUrl + "/updateFileStatus";

            await axios.post(url, {
                "extractionId": extractionId,
                "batchId": batchId,
                "fileId": fileId,
                "status": "confirmed",
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${idToken}`
                }
            }).then(async (response) => {
                if (response.status === 200) {
                    setFileStatus("confirmed");
                    toast.success('File status updated successfully!');

                    // update files data
                    let newFiles = files.map((file) => {
                        if (file.id === fileId) {
                            file.status = "confirmed";
                        }
                        return file;
                    });
                    setFiles(newFiles);

                    // go to next file if there is one, or go to previous or close the modal
                    if (isNextFile()) {
                        await nextFile(true);
                    } else if (isPreviousFile()) {
                        await previousFile(true);
                    } else {
                        await closePopup(true);
                    }
                } else {
                    toast.error('Error updating file status!');
                }
            }).catch((error) => {
                toast.error('Error updating file status!');
            });
        });
    }

    const hasDataChanged = () => {
        return JSON.stringify(data) !== JSON.stringify(initialData);
    }

    const isNextFile = () => {
        return index < fileIds.length - 1;
    }

    const isPreviousFile = () => {
        return index > 0;
    }

    const nextFile = async (skipCheck = false) => {
        try {
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 200));

            const isChangedData = hasDataChanged();

            if (isChangedData && !skipCheck) {
                setNextMoveAfterSaving('next');
                setShowUnsavedChangesAlert(true);
                return;
            }

            setIndex(index + 1);
        } catch (error) {
        }

        setIsLoading(false);
    }

    const previousFile = async (skipCheck = false) => {
        try {
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 200));

            const isChangedData = hasDataChanged();

            if (isChangedData && !skipCheck) {
                setNextMoveAfterSaving('previous');
                setShowUnsavedChangesAlert(true);
                return;
            }

            setIndex(index - 1);
        } catch (error) {
        }
        setIsLoading(false);
    }

    const closePopup = async (skipCheck = false) => {
        try {
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 200));

            const isChangedData = hasDataChanged();

            if (isChangedData && !skipCheck) {
                setNextMoveAfterSaving('close');
                setShowUnsavedChangesAlert(true);
                return;
            }

            closeModal();
        } catch (error) {

        }
    }

    const deleteFile = async () => {
        await currentUser.getIdToken().then(async (idToken) => {
            const url = serverUrl + "/delete";

            await axios.post(url, {
                "extractionId": extractionId,
                "batchId": batchId,
                "fileId": fileId,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${idToken}`
                }
            }).then(async (response) => {
                setShowDeleteFile(false);

                if (response.status === 200) {
                    toast.success('File deleted successfully!');

                    await fetchFiles();

                    if (isNextFile()) {
                        await nextFile(true);
                    } else if (isPreviousFile()) {
                        await previousFile(true);
                    } else {
                        await closePopup(true);
                    }
                } else {
                    toast.error('Error deleting file!');
                }
            }).catch((error) => {
                setShowDeleteFile(false);
                toast.error('Error deleting file!');
            });
        });
    }

    const copyFileLink = async () => {
        navigator.clipboard.writeText(fileUrl);
        toast.success('File link copied to clipboard!');
    }

    const downloadFile = async () => {
        window.open(fileUrl, '_blank');
        toast.success('File opened successfully!');
    };

    const [showUnsavedChangesAlert, setShowUnsavedChangesAlert] = useState(false);
    const [nextMoveAfterSaving, setNextMoveAfterSaving] = useState('');
    const [showExportModal, setShowExportModal] = useState(false);

    const fetchFiles = async () => {
        // load all files and put them in the state
        let files = [];

        let userId = currentUser.uid;
        const databaseRef = ref(db, 'files/' + userId + '/' + extractionId + '/' + batchId);

        try {
            const snapshot = await get(databaseRef);

            if (snapshot.exists()) {
                const data = snapshot.val();

                if (data) {
                    for (let fileId in data) {

                        let file = data[fileId];
                        file.id = fileId;

                        if (initialFileStatus === 'All') {
                            files.push(file);
                        } else if ((file.status === 'processed' || file.status === 'waiting') && initialFileStatus === 'To Review') {
                            files.push(file);
                        } else if (file.status === 'confirmed' && initialFileStatus === 'Confirmed') {
                            files.push(file);
                        } else if (file.status === 'error' && initialFileStatus === 'Error') {
                            files.push(file);
                        }
                    }

                    setFiles(files);
                }
            } else {
                console.log("No data available");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    const transformDBDataToPages = (dbData, documentInfo) => {
        //documentInfo is an object with the following properties:
        //pages: an array of objects with the following properties:
        //pageNumber: the page number
        //width: the width of the page
        //height: the height of the page
        //units: the units of the page
        //and totalPages: the total number of pages

        if (!documentInfo || !documentInfo.pages) {
            return [];
        }

        const pagesMap = {};

        //loop through documentinfo and initialize for every page the sizes
        if (documentInfo.pages) {
            documentInfo.pages.forEach(page => {
                pagesMap[page.pageNumber] = {
                    pageNumber: page.pageNumber,
                    originalWidth: page.width,
                    originalHeight: page.height,
                    fields: [],
                };
            });
        }

        Object.entries(dbData).forEach(([key, value]) => {
            //key doesnt contain box field
            //check if type of value is list
            if (Array.isArray(value)) {
                //foreach value in the list
                value.forEach((item, index) => {
                    if (item.isEmpty) {
                    } else if (!item.box) {
                        //go one level deepe
                        Object.entries(item).forEach(([subKey, subValue]) => {
                            const { pageNumber, box, isEmpty } = subValue;
                            if (isEmpty) {

                            } else {
                                const field = {
                                    topRightX: box.bottom_right.x,
                                    topRightY: box.top_left.y,
                                    bottomLeftX: box.top_left.x,
                                    bottomLeftY: box.bottom_right.y,
                                    key: key + "_" + (index + 1) + "_" + subKey,
                                    commonKeys: [key + "_" + (index + 1) + "_" + subKey]
                                };
                                const existingField = pagesMap[pageNumber].fields.find(e => field.topRightX === e.topRightX && field.topRightY === e.topRightY && field.bottomLeftX === e.bottomLeftX && field.bottomLeftY === e.bottomLeftY);
                                if (existingField) {
                                    existingField.commonKeys.push(key + "_" + (index + 1) + "_" + subKey);
                                } else {
                                    pagesMap[pageNumber].fields.push(field);
                                }
                            }
                        });
                    } else {
                        const { pageNumber, box, isEmpty } = item;
                        if (isEmpty) {

                        } else {
                            const field = {
                                topRightX: box.bottom_right.x,
                                topRightY: box.top_left.y,
                                bottomLeftX: box.top_left.x,
                                bottomLeftY: box.bottom_right.y,
                                key: key + "_" + (index + 1),
                                commonKeys: [key + "_" + (index + 1)]
                            };

                            //if there is a field with same sizes exists already and if so add the key to the existing field
                            const existingField = pagesMap[pageNumber].fields.find(e => field.topRightX === e.topRightX && field.topRightY === e.topRightY && field.bottomLeftX === e.bottomLeftX && field.bottomLeftY === e.bottomLeftY);
                            if (existingField) {
                                existingField.commonKeys.push(key + "_" + (index + 1));
                            } else {
                                pagesMap[pageNumber].fields.push(field);
                            }
                        }
                    }
                });
            } else if (!value.box) {
                //go one level deeper
                Object.entries(value).forEach(([subKey, subValue]) => {
                    const { pageNumber, box } = subValue;
                    const field = {
                        topRightX: box.bottom_right.x,
                        topRightY: box.top_left.y,
                        bottomLeftX: box.top_left.x,
                        bottomLeftY: box.bottom_right.y,
                        key: key + "_" + subKey,
                        commonKeys: [key + "_" + subKey]
                    };
                    const existingField = pagesMap[pageNumber].fields.find(e => field.topRightX === e.topRightX && field.topRightY === e.topRightY && field.bottomLeftX === e.bottomLeftX && field.bottomLeftY === e.bottomLeftY);
                    if (existingField) {
                        existingField.commonKeys.push(key + "_" + subKey);
                    } else {
                        pagesMap[pageNumber].fields.push(field);
                    }
                });
            } else {
                const { pageNumber, box } = value;
                const field = {
                    topRightX: box.bottom_right.x,
                    topRightY: box.top_left.y,
                    bottomLeftX: box.top_left.x,
                    bottomLeftY: box.bottom_right.y,
                    key: key,
                    commonKeys: [key]
                };

                //if there is a field with same sizes exists already and if so add the key to the existing field
                const existingField = pagesMap[pageNumber].fields.find(e => field.topRightX === e.topRightX && field.topRightY === e.topRightY && field.bottomLeftX === e.bottomLeftX && field.bottomLeftY === e.bottomLeftY);
                if (existingField) {
                    existingField.commonKeys.push(key);
                } else {
                    pagesMap[pageNumber].fields.push(field);
                }
            }
        });

        return Object.values(pagesMap);
    }

    const wrapperRef = useRef(null);
    const fieldRefs = useRef({});

    useEffect(() => {
        const handleFocusChange = () => {
            setTimeout(() => {
                if (
                    wrapperRef.current &&
                    !wrapperRef.current.contains(document.activeElement)
                ) {
                    setSelectedKey(null); // 👈 Deselect highlight
                }
            }, 0); // Allow time for focus to shift
        };

        document.addEventListener("focusin", handleFocusChange);
        document.addEventListener("focusout", handleFocusChange);

        return () => {
            document.removeEventListener("focusin", handleFocusChange);
            document.removeEventListener("focusout", handleFocusChange);
        };
    }, []);

    const updateFileClassification = async () => {
        await currentUser.getIdToken().then(async (idToken) => {
            const url = serverUrl + "/documentClassification/updateDocumentType";

            await axios.post(url, {
                "fileId": fileIds[index],
                "classificationId": classificationId,
                "batchId": batchId,
                "documentType": fileDocumentType,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${idToken}`
                }
            }).then(async (response) => {
                if (response.status === 200) {
                    toast.success('File document type updated successfully!');

                    setInitialData(data);
                    setData(data);
                } else {
                    toast.error('Error updating file document type!');
                }
            }).catch((error) => {
                toast.error('Error updating file document type!');
            });
        });
    }

    return (
        <div className='flex flex-col md:flex-row w-full h-full p-4 bg-white rounded-lg shadow-md overflow-auto'>
            <ShowDeleteModalFile
                open={showDeleteFile}
                setOpen={setShowDeleteFile}
                deleteFunction={deleteFile}
            />

            <UnsavedChangesAlert
                open={showUnsavedChangesAlert}
                setOpen={setShowUnsavedChangesAlert}
                nextMoveAfterSaving={nextMoveAfterSaving}
                saveChanges={async () => {
                    await updateFileResult();

                    if (nextMoveAfterSaving === 'next') await nextFile(true);
                    if (nextMoveAfterSaving === 'previous') await previousFile(true);
                    if (nextMoveAfterSaving === 'close') await closePopup(true);

                    setShowUnsavedChangesAlert(false);
                    setIsLoading(false);
                }}
                discardChanges={async () => {
                    if (nextMoveAfterSaving === 'next') await nextFile(true);
                    if (nextMoveAfterSaving === 'previous') await previousFile(true);
                    if (nextMoveAfterSaving === 'close') await closePopup(true);

                    setShowUnsavedChangesAlert(false);
                    setIsLoading(false);
                }}
            />

            <div className="absolute right-0 top-0 pr-5 pt-5 sm:block z-50">
                <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={async () => await closePopup()}
                >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
            </div>

            {/* PDF Viewer Container */}
            <div className="relative md:w-3/5 md:h-full h-full md:mr-5 bg-slate-50 rounded-md border overflow-y-auto">
                {getFileTypeFromUrl(fileUrl) === 'pdf' && (
                    <>
                        {pagesData.length === 0 && (
                            <iframe
                                title={fileName}
                                src={fileUrl}
                                className='w-full h-full bg-slate-50 rounded-md border py-1'
                                frameBorder="0"
                                allowFullScreen
                            ></iframe>
                        )}

                        {pagesData.length !== 0 && (
                            <PDFViewerWithHighlights
                                pdfUrl={fileUrl}
                                pages={pagesData}
                                onFieldClick={handleFieldClick}
                                selectedKey={selectedKey}
                                fieldRefs={fieldRefs}
                                inputRefs={inputRefs}
                                showHighlights={showHighlights}
                                setShowHighlights={setShowHighlights}
                                noCoordinates={noCoordinates}
                            />
                        )}
                    </>
                )}

                {getFileTypeFromUrl(fileUrl) === 'image' && (
                    <>
                        {pagesData.length === 0 && (
                            <img
                                src={fileUrl}
                                alt={fileName}
                                className="w-full h-full bg-slate-50 rounded-md border object-contain py-1"
                            />
                        )}

                        {pagesData.length !== 0 && (
                            <ImageViewerWithHighlights
                                imageUrl={fileUrl}
                                fields={pagesData[0].fields}
                                originalWidth={fileDocumentInfo.pages[0].width}
                                originalHeight={fileDocumentInfo.pages[0].height}
                                onFieldClick={handleFieldClick}
                                selectedKey={selectedKey}
                                fieldRefs={fieldRefs}
                                inputRefs={inputRefs}
                                showHighlights={showHighlights}
                                setShowHighlights={setShowHighlights}
                                noCoordinates={noCoordinates}
                            />
                        )}
                    </>
                )}
            </div>

            <div className={classNames(
                'h-full flex flex-col mr-1 relative',
                (isWordOrError(getFileTypeFromUrl(fileUrl)) ? 'w-full' : 'md:w-2/5')
            )}>
                <div className="flex items-center justify-between">
                    <h2 className="flex items-center gap-2 text-2xl font-bold">
                        <FileText className="h-5 w-5 text-slate-500" />
                        Document Analysis
                    </h2>
                </div>
                <p className="text-gray-500 text-sm">Review and edit extracted data</p>

                {/* File metadata section with improved design */}
                <div className="my-6">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                            <FileText className="h-5 w-5 text-slate-500" />
                            <span className="text-sm font-medium text-slate-700">File Name</span>
                        </div>
                        <span className="text-sm font-mono bg-slate-100 px-2 py-1 rounded">{fileName}</span>
                    </div>

                    {/* <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <CheckCircle className="h-5 w-5 text-slate-500" />
                            <span className="text-sm font-medium text-slate-700">File Status</span>
                        </div>
                        <div
                            variant="outline"
                            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-sm font-medium ${fileStatus === "processed"
                                ? "bg-green-50 text-green-700 border-green-200"
                                : "bg-yellow-50 text-yellow-700 border-yellow-200"
                                }`}
                        >
                            {fileStatus}
                        </div>
                    </div> */}

                    <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-2">
                            <FileType className="h-5 w-5 text-slate-500" />
                            <span className="text-sm font-medium text-slate-700">Document Type</span>
                        </div>
                        <DropdownTypes types={classification.documentTypes.map(type => type.name)} type={fileDocumentType} handleChange={(type) => {
                            setFileDocumentType(type);
                        }} />
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <PercentCircle className="h-5 w-5 text-slate-500" />
                            <span className="text-sm font-medium text-slate-700">Confidence</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-40 h-2 bg-slate-200 rounded-full overflow-hidden">
                                <div
                                    className={`h-full ${fileData?.result.confidence > 0.8
                                        ? "bg-green-500"
                                        : fileData?.result.confidence > 0.5
                                            ? "bg-yellow-500"
                                            : "bg-red-500"
                                        }`}
                                    style={{ width: `${fileData?.result.confidence * 100}%` }}
                                />
                            </div>
                            <span className="text-sm font-medium">{Math.round(fileData?.result.confidence * 100)}%</span>
                        </div>
                    </div>
                </div>

                <div className="relative">
                    <div className="absolute inset-0 flex items-center" aria-hidden="true">
                        <div className="w-full border-t border-gray-300" />
                    </div>
                </div>

                <div className="mt-4">
                    <h3 className="text-base font-medium">Extraction Results</h3>
                </div>

                {extraction && extractionResult && data && fileDocumentType === fileData?.result.documentType ? (
                    <div
                        ref={wrapperRef}
                        className='mt-4 flex-grow rounded-lg md:overflow-auto pr-4 display-result-section'>
                        <DisplayResult
                            result={data}
                            extraction={extraction}
                            handleInputChangeString={handleInputChangeString}
                            handleInputChangeObject={handleInputChangeObject}
                            handleInputChangeArrayString={handleInputChangeArrayString}
                            handleInputChangeArrayObject={handleInputChangeArrayObject}
                            addInputArrayString={addInputArrayString}
                            addInputArrayObject={addInputArrayObject}
                            deleteInputArrayString={deleteInputArrayString}
                            deleteInputArrayObject={deleteInputArrayObject}
                            isLoading={isLoading}
                            inputRefs={inputRefs}
                            onInputFocus={handleInputFocus}
                        />
                    </div>
                ) : (
                    <div className="flex-grow flex items-center justify-center">
                        <div className="text-gray-400 text-sm">
                            {extractionStatus === "waiting" && "Extraction is processing..."}
                            {extractionStatus === "error" && "Extraction failed"}
                            {extractionStatus === null && "No extraction result available"}
                        </div>
                    </div>
                )}


                {hasDataChanged() && (
                    <div className='mt-10 flex items-center justify-between'>
                        <button
                            onClick={updateFileResult}
                            className={classNames(
                                "w-full inline-flex items-center justify-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                (!hasDataChanged() || isLoading) && 'opacity-50 cursor-not-allowed'
                            )}
                            disabled={!hasDataChanged() || isLoading}
                        >
                            Save result
                        </button>
                    </div>
                )}
                {fileData?.result.documentType !== fileDocumentType && (
                    <div className='mt-10 flex items-center justify-between'>
                        <button
                            onClick={updateFileClassification}
                            className={classNames(
                                "w-full inline-flex items-center justify-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                            )}
                        >
                            Save result
                        </button>
                    </div>
                )}

                <div className='mt-6 mb-2 flex items-center justify-end'>
                    <div className='inline-flex items-center'>
                        <button
                            onClick={async () => await previousFile()}
                            className={classNames(
                                "inline-flex items-center text-indigo-500 hover:text-indigo-700",
                                (!isPreviousFile() || isLoading) && 'opacity-50 cursor-not-allowed disabled:text-grey-500'
                            )}
                            disabled={!isPreviousFile() || isLoading}
                        >
                            <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                        <div className='mx-4 text-sm font-medium text-gray-700'>
                            <p>{index + 1} of {fileIds.length}</p>
                        </div>
                        <button
                            onClick={async () => await nextFile()}
                            className={classNames(
                                "inline-flex items-center text-indigo-500 hover:text-indigo-700",
                                (!isNextFile() || isLoading) && 'opacity-50 cursor-not-allowed'
                            )}
                            disabled={!isNextFile() || isLoading}
                        >
                            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>
                </div>
                <div className='pt-5 md:pt-0'></div>
            </div>
        </div>
    );
};

function UnsavedChangesAlert({ open, setOpen, nextMoveAfterSaving, saveChanges, discardChanges }) {
    const cancelButtonRef = useRef(null)

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog className="relative z-100" initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-100 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <ExclamationTriangleIcon className="h-6 w-6 text-orange-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                Unsaved Changes
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                {nextMoveAfterSaving === 'next' && (
                                                    <p className="text-sm text-gray-500">
                                                        You have unsaved changes. Do you want to save them before procedding to the next file?
                                                    </p>)}

                                                {nextMoveAfterSaving === 'previous' && (
                                                    <p className="text-sm text-gray-500">
                                                        You have unsaved changes. Do you want to save them before procedding to the previous file?
                                                    </p>)}

                                                {nextMoveAfterSaving === 'close' && (
                                                    <p className="text-sm text-gray-500">
                                                        You have unsaved changes. Do you want to save them before closing the modal?
                                                    </p>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto"
                                        onClick={saveChanges}
                                    >
                                        Save Changes
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={discardChanges}
                                        ref={cancelButtonRef}
                                    >
                                        Discard Changes
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

function ShowDeleteModalFile({ open, setOpen, deleteFunction }) {
    const cancelButtonRef = useRef(null)

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-100" initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-100 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                Confirm Deletion
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Are you sure you want to delete this file? This action cannot be undone.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                        onClick={() => deleteFunction()}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => setOpen(false)}
                                        ref={cancelButtonRef}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

function DisplayResult({
    result,
    extraction,
    handleInputChangeString,
    handleInputChangeObject,
    handleInputChangeArrayString,
    handleInputChangeArrayObject,
    addInputArrayString,
    addInputArrayObject,
    deleteInputArrayString,
    deleteInputArrayObject,
    isLoading,
    inputRefs,
    onInputFocus
}) {
    if (isLoading) {
        return (
            <>
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="mb-4 flex flex-col gap-x-2 p-4 border border-gray-200 rounded-lg bg-slate-50">
                        <div className="flex items-center">
                            <span className="w-1/2 font-bold break-words pr-4">
                                <Skeleton />
                            </span>
                            <div className="w-1/2 relative">
                                <Skeleton />
                            </div>
                        </div>
                    </div>
                ))}
            </>
        )
    }

    return (
        <div className='flex flex-col gap-y-4'>
            {extraction.fields.map((field, index) => {
                let fieldType = field.type ?? 'string';
                let itemsType = field.items?.type ?? 'string';
                let key = field.key;

                if (fieldType === "string") {
                    let resultData = result[key] ?? '';

                    return (
                        <div
                            className="flex flex-col gap-x-2 p-4 border border-gray-200 rounded-lg bg-slate-50"
                            key={index}
                        >
                            <div className="flex items-center">
                                <span className="w-1/2 font-bold break-words pr-4">
                                    {key}
                                </span>
                                <div className="w-1/2 relative">
                                    <input
                                        ref={(el) => (inputRefs.current[key] = el)}
                                        onFocus={() => {
                                            onInputFocus?.(key);
                                        }}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            handleInputChangeString(key, e.target.value);
                                        }}
                                        type="text"
                                        name="value"
                                        id="value"
                                        value={resultData}
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        placeholder="add a value"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    )
                } else if (fieldType === "object") {
                    let resultData = result[key] ?? {};

                    // Extract and sort the keys based on their IDs from field.properties
                    // const sortedInnerKeys = Object.keys(resultData).sort((a, b) => {
                    //     const idA = field.properties.find(property => property.key === a).id;
                    //     const idB = field.properties.find(property => property.key === b).id;
                    //     return idA - idB;
                    // });
                    const sortedInnerKeys = Object.keys(resultData).sort((a, b) => {
                        const propertyA = field.properties.find(property => property.key === a);
                        const propertyB = field.properties.find(property => property.key === b);

                        const idA = propertyA ? propertyA.id : Number.MAX_SAFE_INTEGER;
                        const idB = propertyB ? propertyB.id : Number.MAX_SAFE_INTEGER;

                        return idA - idB;
                    });

                    return (
                        <div
                            className="flex flex-col gap-x-2 p-4 border border-gray-200 rounded-lg bg-slate-50"
                            key={index}
                        >
                            <div className="mb-4">
                                <span className="font-bold">
                                    {key}
                                </span>
                            </div>
                            <div className="flex flex-col pl-4 gap-y-3.5">
                                {sortedInnerKeys.map((innerKey, indexKey) => {
                                    return (
                                        <div className="flex items-center">
                                            <span
                                                key={indexKey}
                                                className={classNames(
                                                    'inline-block h-2 w-2 flex-shrink-0 rounded-full mr-3.5',
                                                    true ? 'bg-indigo-500' : 'bg-gray-200'
                                                )}
                                                aria-hidden="true"
                                            />
                                            <div className="relative w-full">
                                                <label
                                                    htmlFor="name"
                                                    className="absolute -top-2 left-2 inline-block bg-white rounded px-1 text-xs font-medium text-gray-900"
                                                >
                                                    {innerKey}
                                                </label>
                                                <input
                                                    ref={(el) => (inputRefs.current[key + "_" + innerKey] = el)}
                                                    onFocus={() => {
                                                        onInputFocus?.(key + "_" + innerKey);
                                                    }}
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        handleInputChangeObject(key, innerKey, e.target.value);
                                                    }}
                                                    type="text"
                                                    name="value"
                                                    id="value"
                                                    value={resultData[innerKey]}
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    placeholder="add a value"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                } else if (fieldType === "array" && itemsType === "string") {
                    let resultData = result[key] ?? [];
                    let numberOfItems = resultData.length ?? 0;

                    return (
                        <div
                            className="flex flex-col gap-x-2 p-4 border border-gray-200 rounded-lg bg-slate-50"
                            key={index}
                        >
                            <div className="mb-3">
                                <div className="flex items-center justify-between">
                                    <span className="font-bold">
                                        {key}
                                    </span>
                                    <span className="text-sm text-gray-500">
                                        {numberOfItems} {numberOfItems === 1 ? "item" : "items"}
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-col pl-4 gap-y-3.5">
                                {Object.keys(resultData).map((innerKey, indexKey) => {
                                    const innerKeyInt = parseInt(innerKey, 10) + 1;
                                    return (
                                        <div className="flex items-center">
                                            <span className='mr-2.5 font-bold text-indigo-500'>
                                                {indexKey + 1}.
                                            </span>
                                            <div className="relative w-full">
                                                <input
                                                    ref={(el) => (inputRefs.current[key + "_" + innerKeyInt] = el)}
                                                    onFocus={() => {
                                                        onInputFocus?.(key + "_" + innerKeyInt);
                                                    }}
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        handleInputChangeArrayString(key, indexKey, e.target.value);
                                                    }}
                                                    type="text"
                                                    name="value"
                                                    id="value"
                                                    value={resultData[innerKey]}
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    placeholder="add a value"
                                                    required
                                                />
                                            </div>
                                            {/* remove button if there are multiple items */}
                                            {resultData.length > 1 && (
                                                <button
                                                    onClick={() => deleteInputArrayString(key, indexKey)}
                                                    className={classNames(
                                                        'bg-red-400 hover:bg-red-500 w-4 h-4 flex items-center justify-center rounded-full ml-3 p-1',
                                                    )}
                                                    aria-label="Remove"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H4" />
                                                    </svg>
                                                </button>
                                            )}
                                        </div>
                                    )
                                })}
                                <button
                                    onClick={() => addInputArrayString(key)}
                                    className="pl-7 inline-flex items-center gap-x-1.5 text-sm font-semibold text-indigo-600 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Add item
                                </button>
                            </div>
                        </div>
                    )
                } else if (fieldType === "array" && itemsType === "object") {
                    let resultData = result[key] ?? [];
                    let numberOfItems = resultData.length ?? 0;

                    return (
                        <div
                            className="flex flex-col gap-x-2 p-4 border border-gray-200 rounded-lg bg-slate-50"
                            key={index}
                        >
                            <div className="mb-4">
                                <div className="flex items-center justify-between">
                                    <span className="font-bold">
                                        {key}
                                    </span>
                                    <span className="text-sm text-gray-500">
                                        {numberOfItems} {numberOfItems === 1 ? "item" : "items"}
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-col pl-4 gap-y-3.5">
                                {Object.keys(resultData).map((innerKey, indexKey) => {
                                    let objectData = resultData[innerKey];
                                    let innerKeyInt = parseInt(innerKey, 10) + 1;

                                    // const sortedKeys = Object.keys(objectData).sort((a, b) => {
                                    //     const idA = field.items.properties.find(property => property.key === a).id;
                                    //     const idB = field.items.properties.find(property => property.key === b).id;
                                    //     return idA - idB;
                                    // });

                                    const defaultId = Number.MAX_SAFE_INTEGER; // A large number to ensure properties without IDs are at the end

                                    const sortedKeys = Object.keys(objectData).sort((a, b) => {
                                        const propertyA = field.items.properties.find(property => property.key === a);
                                        const propertyB = field.items.properties.find(property => property.key === b);

                                        const idA = propertyA && propertyA.id !== undefined ? propertyA.id : defaultId;
                                        const idB = propertyB && propertyB.id !== undefined ? propertyB.id : defaultId;

                                        return idA - idB;
                                    });

                                    return (
                                        <div className="flex items-start">
                                            <span className='inline-block h-2 w-2 flex-shrink-0 rounded-full mr-4 font-bold text-indigo-500'>
                                                {indexKey + 1}.
                                            </span>
                                            <div className="w-full flex flex-col gap-y-4">
                                                {sortedKeys.map((innerInnerKey) => {
                                                    return (
                                                        <div className="flex items-center">
                                                            <div className="relative w-full">
                                                                <label
                                                                    htmlFor="name"
                                                                    className="absolute -top-2 left-2 inline-block bg-white rounded px-1 text-xs font-medium text-gray-900"
                                                                >
                                                                    {innerInnerKey}
                                                                </label>
                                                                <input
                                                                    ref={(el) => (inputRefs.current[key + "_" + innerKeyInt + "_" + innerInnerKey] = el)}
                                                                    onFocus={() => {
                                                                        onInputFocus?.(key + "_" + innerKeyInt + "_" + innerInnerKey);
                                                                    }}
                                                                    onChange={(e) => {
                                                                        e.preventDefault();
                                                                        handleInputChangeArrayObject(key, indexKey, innerInnerKey, e.target.value);
                                                                    }}
                                                                    type="text"
                                                                    name="value"
                                                                    id="value"
                                                                    value={objectData[innerInnerKey]}
                                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                                    placeholder="add a value"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                {/* add divider if object data is not the last one */}
                                                {indexKey !== resultData.length - 1 && (
                                                    <div className="border-t border-gray-200 mb-1"></div>
                                                )}
                                            </div>
                                            {resultData.length > 1 && (
                                                <button
                                                    onClick={() => deleteInputArrayObject(key, indexKey)}
                                                    className={classNames(
                                                        'bg-red-400 hover:bg-red-500 w-4 h-4 flex items-center justify-center rounded-full ml-3 p-1 mt-2',
                                                    )}
                                                    aria-label="Remove"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H4" />
                                                    </svg>
                                                </button>
                                            )}
                                        </div>
                                    )
                                })}
                                <button
                                    onClick={() => addInputArrayObject(key)}
                                    className="pl-7 inline-flex items-center gap-x-1.5 text-sm font-semibold text-indigo-600 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Add item
                                </button>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div></div>
                    )
                }
            })}
        </div >
    )
}

function DropdownTypes({ types, type, handleChange }) {
    const handleChangeLocal = (type) => {
        handleChange(type);
    }

    return (
        <Listbox value={type} onChange={handleChangeLocal}>
            {({ open }) => (
                <>
                    {/* <Listbox.Label className="block text-sm font-medium leading-6 text-gray-900">Assigned to</Listbox.Label> */}
                    <div className="relative w-48">
                        <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                            <span className="block truncate">{type}</span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                {types.map((person) => (
                                    <Listbox.Option
                                        key={person}
                                        className={({ active }) =>
                                            classNames(
                                                active ? 'bg-indigo-600 text-white' : 'text-gray-900',
                                                'relative cursor-default select-none py-2 pl-8 pr-4'
                                            )
                                        }
                                        value={person}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                    {person}
                                                </span>

                                                {selected ? (
                                                    <span
                                                        className={classNames(
                                                            active ? 'text-white' : 'text-indigo-600',
                                                            'absolute inset-y-0 left-0 flex items-center pl-1.5'
                                                        )}
                                                    >
                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}

export default ViewFile;